import { render, staticRenderFns } from "./AddRate.vue?vue&type=template&id=e705a1f2&scoped=true"
import script from "./AddRate.vue?vue&type=script&lang=js"
export * from "./AddRate.vue?vue&type=script&lang=js"
import style0 from "./AddRate.vue?vue&type=style&index=0&id=e705a1f2&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e705a1f2",
  null
  
)

export default component.exports